<template>
  <header class="header topbar">
    <nav class="navbar top-navbar navbar-dark">
      <div class="navbar-header">
        <a href="/sales-summary">
          <img
            src="/images/Tokoin-Logo.svg?=2"
            alt="Tokoin"
            width="190"
            class="img-fluid main-header-logo"
          />
        </a>
      </div>

      <ul class="list-unstyled mb-0">
        <li class="nav-item dropdown my-account-dd">
          <a
            class="nav-link dropdown-toggle text-dark waves-effect waves-dark pro-pic f-semi-bold"
            href
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <img
              :src="user.image ? user.image: '/images/icon_profile.svg'"
              alt="user"
              class="rounded-circle header-uer-pic mr-2"
              width="40"
              height="40"
            />
            {{ user.name || user.email }}
            <i
              class="fa fa-angle-down align-middle"
              aria-hidden="true"
            ></i>
          </a>
          <div class="dropdown-menu dropdown-menu-right user-dd animated pt-3">
            <a class="dropdown-item font-16" href="/profile">
              <i class="ti-user m-r-5 m-l-5"></i>
              {{$lang.messages.profile}}
            </a>

            <a class="dropdown-item font-16" href="/settings">
              <i class="ti-settings m-r-5 m-l-5"></i>
              {{$lang.messages.setting}}
            </a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item font-16" @click="logout" href="javascript:void(0)">
              <i class="fa fa-power-off m-r-5 m-l-5"></i>
              {{$lang.messages.logout}}
            </a>
          </div>
        </li>
      </ul>
    </nav>
  </header>
</template>

<script>
import EventBus from "../eventBus";
import router from "../router";
export default {
  name: "Header",
  data() {
    return {
      name: null,
      locale: "en",
      user: {
        id: "",
        name: "",
        email: "",
        phone_number: "",
        image: "",
        password: ""
      }
    };
  },
  methods: {
    logout() {
      const locale = localStorage.getItem('locale') || 'id'
      localStorage.clear();
      this.$shareService.clearMap();
      router.push(`/login?lang=${locale}`);
    },

    getMe() {
      this.$api
        .getAPI({
          _action: `/me?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}`
        })
        .then(res => {
          if (res.days) {
            localStorage.setItem("days", res.days);
          }
          var locale = 'en'
          if (res.language != null && res.language.code != null) {
            locale = res.language.code
          }
          this.$lang.setLang(locale);
          localStorage.setItem("locale", locale);
          localStorage.setItem("d2c_type", res.user.d2c_type);

          localStorage.setItem("accessright", JSON.stringify(res.access_right));

          this.user = res.user;
          this.user.id = res.user.id;
          this.user.name = res.user.name;
          this.user.email = res.user.email;
          this.user.phone_number = res.user.phone_number;
          this.user.image = res.user.image;
          this.$moment.locale(localStorage.getItem('locale') || 'en-gb')
          localStorage.setItem("timezone", JSON.stringify(res.timezone));
          EventBus.$emit("GET_ME_SUCCESS", res);
        });
    }
  },
  mounted() {
    this.name = this.$shareService.getMapValue("user-name")
    EventBus.$on("DATA_PUBLISHED", () => {
      this.getMe()
    })
  },

  async created() {
    await this.getMe()
  },

  watch: {
    "$route": function() {
      this.getMe()
    }
  }
};
</script>
